<template>
    <div class="contact-detail-view">
        <contact-detail v-if="contact" :contact="contact"/>
    </div>
</template>

<script>
import ContactDetail from '@/components/ContactDetail'

export default {
  components: {
    ContactDetail
  },
  computed: {
    id () {
      return this.$route.params.id
    },
    contact () {
      return this.$store.getters.getContactById(this.id)
    }
  }
}
</script>

<style scoped>
.contact-detail-view {
  padding-left: 8px;
  padding-right: 8px;
  padding-top: 20px;
  padding-bottom: 100px;
  background: white;
  position: absolute;
  top: 0;
  right: 0;
  left:0;
  height: 100vh;
  max-height: 100vh;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
}
</style>




// WEBPACK FOOTER //
// src/components/views/ContactDetailView.vue